export default __webpack_public_path__ + "static/media/descargar-referencia.1b27819d.svg";